import { render, staticRenderFns } from "./Apps.vue?vue&type=template&id=5c615782&scoped=true"
import script from "./Apps.vue?vue&type=script&lang=ts"
export * from "./Apps.vue?vue&type=script&lang=ts"
import style0 from "./Apps.vue?vue&type=style&index=0&id=5c615782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c615782",
  null
  
)

export default component.exports